import { render } from "./CatGrupoEmpleadoView.vue?vue&type=template&id=8977ae24&scoped=true"
import script from "./CatGrupoEmpleadoView.vue?vue&type=script&lang=js"
export * from "./CatGrupoEmpleadoView.vue?vue&type=script&lang=js"

import "./CatGrupoEmpleadoView.vue?vue&type=style&index=0&id=8977ae24&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8977ae24"]])

export default __exports__